export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'blur' },
    ],
    name: [
        { required: true, message: 'Пожалуйста, введите Код ', trigger: 'blur' },
    ],
};
